/**
 * Search results map/list mode constants (Milestone 6).
 *
 * Audit (M6):
 * - AutoMapa vehicle search has NO Mapbox map wired (unlike ListingSearchTemplate for golf RE).
 * - gridMode toggles card grid vs list layout only — not geographic map.
 * - ClientViewListingsMap exists for real-estate client views, not vehicle inventory.
 * - Normalized listings support latitude/longitude but public inventory rarely includes them.
 *
 * Enabled when the same public Mapbox token used by Midpoint Map is configured at build time.
 */
export const AUTOMAPA_SEARCH_MAP_ENABLED = Boolean(
  String(process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || "").trim()
);

/** @typedef {'list' | 'map' | 'split'} SearchResultsViewMode */

export const SEARCH_RESULTS_VIEW_MODE = {
  LIST: "list",
  MAP: "map",
  SPLIT: "split",
};

export const SEARCH_VIEW_MODE_COPY = {
  list: "Lista",
  map: "Mapa",
  split: "Lista y mapa",
  layoutGrid: "Vista tarjetas",
  layoutList: "Vista lista",
  layoutGridAria: "Cambiar a vista de tarjetas",
  layoutListAria: "Cambiar a vista de lista",
  unmappedNotice: "Algunos vehículos no tienen ubicación exacta y solo aparecen en la lista.",
  unmappedCount: (count) =>
    `${count} vehículo${count === 1 ? "" : "s"} sin ubicación exacta`,
  mapScopeHint: "El mapa muestra los resultados visibles.",
  mapLoading: "Cargando mapa…",
  mapUnavailable: "El mapa no está disponible en este momento.",
};

/** Default map center — Medellín metro (used when map is re-enabled). */
export const AUTOMAPA_SEARCH_MAP_DEFAULTS = {
  center: [-75.5636, 6.2518],
  zoom: 11,
};
